const templatesList = {
    namespaced: true,
    state: {
        status: "0",
        search: null,
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "template_name" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    },
    mutations: {
        SET_STATUS (state, payload) {
            state.status = payload;
        },
        SET_TABLE_SEARCH (state, payload) {
            state.search = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        }
    },
    getters: {
        getStatus: (s) => s.status,
        getTableSearch: (s) => s.search,
        getTableOptions: (s) => s.tableOptions,
    }
}

export default templatesList;